<template>
  <div class="historyLocation" :class="{ yellow: isPicked }" v-on="$listeners">
    <h4 class="col-md-4 historyLocation__title">
      <input
        type="radio"
        class="historyLocation__radio"
        name="address"
        :checked="isPicked"
        @change="$emit('click')"
      />
      乘客曾經上車位置:
    </h4>
    <div class="col-md-8">
      <select
        class="historyLocation__select"
        multiple
        v-model="gps"
        @change="setHistoryAddress()"
      >
        <option
          v-for="(info, index) in customerHistoryInfo.getInInfors"
          :key="index"
          :value="info.getinInformation"
          :class="customerHistoryInfo.classStyle[index]"
        >
          {{ info.getinInformation.onLocation }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isPicked: Boolean,
    customerHistoryInfo: Object,
  },
  data() {
    return {
      gps: [],
    }
  },
  methods: {
    resetState() {
      this.gps = []
    },
    setHistoryAddress() {
      const value = {
        address: this.gps[0].onLocation,
        latitude: this.gps[0].passenger_getin_gps.coordinates[1],
        longitude: this.gps[0].passenger_getin_gps.coordinates[0],
      }

      // 將乘客歷史資料放在暫存參數
      this.$emit('update-location', value)
    },
  },
}
</script>
<style lang="scss" scoped>
.historyLocation {
  padding-top: 5px;
  padding-bottom: 5px;
  border-right: #989898 solid 2px;

  &__title {
    font-size: 18px;
    color: black;
    margin: 0;
    margin-left: 15px;
    margin-right: -15px;
    height: 36px;
    line-height: 36px;
    max-width: 247.15px;
  }

  &__radio {
    margin: 0;
    height: 36px;
    vertical-align: top;
  }

  &__select {
    width: calc(100% - 15px);
    height: 100px;
    padding: 6px 12px;
    font-size: 16px;
    color: #555;
    background-color: #fff;
    border: 1px solid #ccc;
    margin-left: 15px;
  }

  .yellow {
    background-color: #ffffb3;
  }

  .multiple_select {
    height: 100px;
  }

  .hailing_address_red {
    background-color: #ff1a1a;
  }
  .color_gray {
    color: gray;
  }
}
</style>



// WEBPACK FOOTER //
// src/mixins/PhoneHail/HistoryLocation.vue